import { resolveSupportPageUrl } from 'src/Shared/utils/resolveSupportPageUrl';
import { getLocalePrefix } from 'src/Shared/utils/get-locale-prefix';
export var generateVideoUrl = function (product, videoId, absolute) {
    if (!videoId) {
        return undefined;
    }
    resolveSupportPageUrl(product);
    var localePrefix = getLocalePrefix();
    var basePath = product.supportPageUrl + "/" + product.sku + "/video/" + videoId;
    var url = localePrefix && !basePath.startsWith(localePrefix)
        ? "" + localePrefix + basePath
        : basePath;
    return absolute ? window.location.protocol + "//" + window.location.host + url : url;
};
